<template>
  <SpotifyPlaylistTracks client_name="MID" />
</template>

<script>
import axios from "axios";
import $ from "jquery";
import SpotifyPlaylistTracks from "@/components/music_library/SpotifyPlaylistTracks.vue";

export default {
  name: "MIDMusicLibrarySpotifyPlaylistTracks",
  components: { SpotifyPlaylistTracks },
  data() {
    return {};
  },
  mounted() {
    // this.getEventsList();
  },
  computed: {},
  created() {},
  methods: {
    getEventsList() {
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token)
      axios
        .get("event/events", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "MID",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.events = response.data;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/music_library/SpotifyPlaylistTracks.vue